
// src/components/ailab-chat/PersonaSelector.js

import React, { useState, useMemo } from 'react';
import { Search } from 'lucide-react';

const PersonaSelector = ({ personas, selectedPersonaId, onSelectPersona }) => {
  const [searchQuery, setSearchQuery] = useState('');

  // Filter personas based on search query
  const filteredPersonas = useMemo(() => {
    if (!searchQuery) return personas;
    const lowerQuery = searchQuery.toLowerCase();
    return personas.filter(p => 
      p.koruName.toLowerCase().includes(lowerQuery) || 
      (p.handle && p.handle.toLowerCase().includes(lowerQuery))
    );
  }, [personas, searchQuery]);

  return (
    <aside className="persona-selector">
      <div className="persona-selector-header-container">
        <div className="persona-selector-header">AI Experts</div>
        <div className="persona-search-container">
          <Search size={16} className="persona-search-icon" />
          <input 
            type="text" 
            placeholder="Search experts..." 
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="persona-search-input"
          />
        </div>
      </div>
      
      <nav className="persona-selector-nav">
        {filteredPersonas.length === 0 ? (
          <div className="persona-no-results">No experts found.</div>
        ) : (
          filteredPersonas.map((persona) => (
            <button
              key={persona.id}
              onClick={() => onSelectPersona(persona.id)}
              className={`persona-button ${selectedPersonaId === persona.id ? 'selected' : ''}`}
            >
              <img
                src={persona.avatarUrl}
                alt={persona.koruName}
                className="persona-avatar"
              />
              <div className="persona-info">
                <p className="persona-info-name">{persona.koruName}</p>
                <p className="persona-info-handle">{persona.handle}</p>
              </div>
            </button>
          ))
        )}
      </nav>
    </aside>
  );
};

export default PersonaSelector;
